import { Grid, Typography, Box } from '@mui/material';
import { useRouter } from 'next/router';
import Image from 'next/legacy/image';
import * as S from './styles';

const FormBaseLayout: React.FC<React.ReactNode> = ({
  children
}): JSX.Element => {
  const router = useRouter();
  const redirectToLogin = () => router.push('/register/email');

  return (
    <S.Container container>
      <S.Wrapper
        sx={{
          // maxHeight: { xs: '100%', md: '70vh' },
          // marginBottom: '7rem',
          width: '100%'
        }}
      >
        {router.pathname === '/signin' ? (
          <S.TopDiv>
            <S.Button onClick={() => redirectToLogin()}>
              <p>Crie uma nova conta por email</p>
              <Image
                src={'/icons/arrowRightBlack.svg'}
                alt=""
                width={20}
                height={14}
              />
            </S.Button>

            <p>ou</p>

            <p>
              <span>Entre</span> com sua conta
            </p>
          </S.TopDiv>
        ) : null}

        {children}

        {/* Create account - DESKTOP */}
        <Grid
          item
          sx={{
            display: { xs: 'none', md: 'flex' },
            marginTop: '4.8rem'
          }}
        >
          <Box
            sx={{
              height: '4.8rem',
              width: '4.8rem',
              background: '#045AE5',
              display: 'grid',
              placeItems: 'center',
              marginRight: '2.4rem'
            }}
          >
            <Image
              src="/icons/riderize-R.svg"
              alt="Ícone Riderize"
              width={24}
              height={22}
            />
          </Box>

          <Grid>
            <Typography sx={{ color: '#fff', fontSize: '1.6rem' }}>
              © Riderize
            </Typography>

            <Typography sx={{ color: '#fff', fontSize: '1.6rem' }}>
              Todos os direitos reservados
            </Typography>
          </Grid>
        </Grid>
      </S.Wrapper>
    </S.Container>
  );
};

export default FormBaseLayout;
